<script>
import { mapGetters } from 'vuex';
import LabelsIndex from '../../labels/Index.vue';

export default {
  components: {
    LabelsIndex,
  },
  props: {
    inbox: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({
      allLabels: 'labels/getLabels',
    }),
    inboxLabels() {
      if (!this.inbox.id) return [];

      return this.allLabels.filter(label => {
        // Se inbox_ids é null (label antiga não classificada), não mostrar
        if (label.inbox_ids === null) return false;

        // Se inbox_ids é array vazio, disponível para todas
        if (Array.isArray(label.inbox_ids) && label.inbox_ids.length === 0) {
          return true;
        }

        // Verificar se inbox está na lista
        return Array.isArray(label.inbox_ids) && label.inbox_ids.includes(this.inbox.id);
      });
    },
  },
  mounted() {
    this.$store.dispatch('labels/get');
  },
  provide() {
    return {
      inboxId: this.inbox.id,
      inboxLabels: this.inboxLabels,
    };
  },
};
</script>

<template>
  <div class="labels-page">
    <div class="mb-4 p-4 bg-n-slate-2 rounded-md border border-n-slate-6">
      <p class="text-sm text-n-slate-11">
        <strong>Labels da Inbox:</strong> Gerencie labels específicas para "{{ inbox.name }}".
        As labels criadas aqui estarão disponíveis apenas nesta inbox.
      </p>
    </div>

    <LabelsIndex :inbox-id="inbox.id" />
  </div>
</template>

<style scoped>
.labels-page {
  margin-top: 0;
}
</style>
